"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_API_VERSION = exports.RIPPLED_API_V2 = exports.RIPPLED_API_V1 = void 0;
exports.RIPPLED_API_V1 = 1;
exports.RIPPLED_API_V2 = 2;
exports.DEFAULT_API_VERSION = exports.RIPPLED_API_V2;
//# sourceMappingURL=index.js.map